// extracted by mini-css-extract-plugin
export default {"caption":"caption_caption__PjXYa","captionRight":"caption_captionRight__K3gEP","captionCenter":"caption_captionCenter__g09u9","captionGreen":"caption_captionGreen__xxD4Y"};